import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {passwordChangeMutationType} from "./__graphql-types__/index.ts";

const CHANGE_PASSWORD_MUTATION: GqlOperation<
    passwordChangeMutationType["response"],
    passwordChangeMutationType["variables"]
> = gqlOp(gql`
    mutation passwordChangeMutation(
        $kaid: String!
        $password: String!
        $oldPassword: String
    ) {
        passwordChange(
            kaid: $kaid
            password: $password
            oldPassword: $oldPassword
        ) {
            error {
                code
            }
        }
    }
`);

export default CHANGE_PASSWORD_MUTATION;
